"use strict";
/**
 * web 页面的逻辑
 * - 取得 device info 和 app info
 * - 发请求
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.amonsulEvent = exports.amonsul = exports._createEt = exports._getAppInfo = exports._getDeviceInfo = exports._getDid = void 0;
var tslib_1 = require("tslib");
var const_1 = require("./const");
var fe_utils_1 = require("@douban/fe-utils");
var ua_parser_js_1 = (0, tslib_1.__importDefault)(require("ua-parser-js"));
var fe_utils_2 = require("@douban/fe-utils");
var utils_1 = require("./utils");
var ua_1 = (0, tslib_1.__importDefault)(require("@douban/rexxar-common/es/assets/js/ua"));
var version_1 = require("@douban/rexxar-common/es/assets/js/version");
var uaParser = new ua_parser_js_1.default();
// 使用 bid 当做 did
function _getDid(did) {
    return did || fe_utils_1.Cookie.get('bid');
}
exports._getDid = _getDid;
function _getDeviceInfo(g, did) {
    if (g === void 0) { g = window; }
    var current_app = (0, utils_1.getCurrentApp)(g, 'getDeviceInfo');
    if (current_app.getDeviceInfo) {
        var di = current_app.getDeviceInfo();
        if (!di) {
            return {};
        }
        if (typeof (di) === 'string') {
            return JSON.parse(di);
        }
        return di;
    }
    var os = uaParser.getOS();
    return {
        did: did || _getDid(),
        os: os.name && os.name === 'Android' ? os.name.toLowerCase() : os.name,
        osv: os.version
    };
}
exports._getDeviceInfo = _getDeviceInfo;
function _getAppInfo(g) {
    if (g === void 0) { g = window; }
    var current_app = (0, utils_1.getCurrentApp)(g, 'getAppInfo');
    if (current_app.getAppInfo) {
        var ai = current_app.getAppInfo();
        if (typeof (ai) === 'string') {
            // 某些 iOS 版本的 abt 会有问题，所以需要删除
            var _ai = ai.replace(/,"abt":"{"[^}]+}"/gi, '');
            return JSON.parse(_ai);
        }
        return ai;
    }
    return { ui: '' };
}
exports._getAppInfo = _getAppInfo;
function _createEt(et, ai) {
    return (0, tslib_1.__assign)({ tm: Date.now(), vn: ai === null || ai === void 0 ? void 0 : ai.vc }, et);
}
exports._createEt = _createEt;
var amonsul = function (props) {
    var did = props.did, _a = props.app_name, app_name = _a === void 0 ? (0, utils_1.getAppName)() : _a, _b = props.apikey, apikey = _b === void 0 ? (0, utils_1.getApiKey)() : _b, logs = props.logs;
    var _c = logs || {}, _d = _c.ai, ai = _d === void 0 ? {} : _d, _e = _c.di, di = _e === void 0 ? {} : _e, _f = _c.ets, ets = _f === void 0 ? [] : _f;
    var _ai = (0, tslib_1.__assign)((0, tslib_1.__assign)({}, _getAppInfo()), ai);
    var _di = (0, tslib_1.__assign)((0, tslib_1.__assign)({}, _getDeviceInfo()), di);
    var _ets = ets === null || ets === void 0 ? void 0 : ets.map(function (et) { return _createEt(et); });
    // 7.22 以下版本不发送请求
    // @王琦 如果客户端取不到呢？那是传bid还是空着？
    // @季楠 空着，会过滤掉，什么情况会取不到呢？
    // @王琦 7.22 版本以下
    // 那7.22以下可以不上报？
    // 这样也行，但是应该会少一部分数据？
    // @季楠 嗯，没事，目前did错了也没法正常统计
    if (ua_1.default.isFrodo() && !version_1.frdVersion.since('7.22.0')) {
        return;
    }
    return fe_utils_2.axios.post(const_1.AMONSUL_API, {
        did: did || _di.did || _getDid(),
        app_name: app_name,
        apikey: apikey,
        logs: {
            ai: _ai,
            di: _di,
            ets: _ets,
        }
    }, {
        withCredentials: true
    });
};
exports.amonsul = amonsul;
function amonsulEvent(nm, label, appInfo, deviceInfo) {
    var lb = label ? (0, tslib_1.__assign)({}, label) : {};
    var et = _createEt({
        nm: nm,
        lb: JSON.stringify(lb)
    });
    try {
        (0, exports.amonsul)({
            logs: {
                ai: appInfo,
                di: deviceInfo,
                ets: [et]
            }
        });
    }
    catch (e) { }
}
exports.amonsulEvent = amonsulEvent;
//# sourceMappingURL=web.js.map